/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';


/* ++++++++++ --------------- CHANGE BADGE : STYLES --------------- ++++++++++ */
export default {
    adplacement: {
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      textAlign: 'center',
      position: 'relative',
      zIndex: 10,
      background: 'linear-gradient(235.22deg, #FF9882 0%, #FFEB82 100%)',
    }
}
